import { render, staticRenderFns } from "./SubtitlesStaticSegment.vue?vue&type=template&id=002e8b8e&scoped=true"
import script from "./SubtitlesStaticSegment.vue?vue&type=script&lang=js"
export * from "./SubtitlesStaticSegment.vue?vue&type=script&lang=js"
import style0 from "./SubtitlesStaticSegment.vue?vue&type=style&index=0&id=002e8b8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002e8b8e",
  null
  
)

export default component.exports